import { gsap } from '../global/gsap';

const initBookingOverlays = (toggles) => {
    const body = document.querySelector('.js-body');
    const bookingOverlay = document.querySelector('.js-booking-overlay');
    const overlayContent = document.querySelector('.js-booking-overlay-content');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'overlay-active';
    let isActive = false;

    const overlayTl = gsap.timeline();

    gsap.set(bookingOverlay, {
        autoAlpha: 0,
    });

    gsap.set(overlayContent, {
        autoAlpha: 0,
        yPercent: 25
    });

    overlayTl.to(bookingOverlay, {autoAlpha: 1, duration: .75});

    overlayTl.to(overlayContent, {autoAlpha: 1, yPercent: 0, stagger: .1, duration: .300}, "-=.5");

    overlayTl.add(() => {
        if (isActive) {
            bookingOverlay.style.pointerEvents = 'all';
        } else {
            bookingOverlay.style.pointerEvents = 'none';
        }
    });

    overlayTl.pause();

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            isActive = !isActive;

            if (isActive) {
                body.classList.add(stopScrollingClass, isActiveClass);
                overlayTl.timeScale(1).play();
            } else {
                body.classList.remove(stopScrollingClass, isActiveClass);
                bookingOverlay.style.pointerEvents = 'none';
                overlayTl.timeScale(2).reverse();
            }
        });
    });
};

export { initBookingOverlays as default };